import I18n from 'components/I18n'
import Text from 'components/Text'
import { selectors } from 'data'
import { SingleProductEligibility } from 'data/Eligibility/types'
import messages from 'lang'
import React from 'react'
import { useSelector } from 'react-redux'

import { Empty } from '../Deposit/Crypto/styles'
import EligibilityNotifications from '../EligibilityNotifications'
import Rows from '../Rows'
import { BodyTitle, ModalContainer } from '../styles'

type Props = {
  eligibility: SingleProductEligibility
  isWithdraw: boolean
  onItemClick: (currency: string) => void
  options: Array<string>
}
const StableOptions = ({ eligibility, isWithdraw, onItemClick, options }: Props) => {
  const currencies = useSelector(selectors.currencies.getCurrencies)

  const rows = options.map((option) => ({
    onClick: () => onItemClick(option),
    symbol: option,
    title: currencies.find((c) => c.symbol === option)?.name,
    type: 'currency'
  }))

  if (!eligibility.enabled) {
    return (
      <EligibilityNotifications
        context={isWithdraw ? 'WITHDRAW' : 'DEPOSIT'}
        reason={eligibility.reasonNotEligible}
      />
    )
  }

  return (
    <ModalContainer>
      <BodyTitle>
        <Text weight={600} textTransform='capitalize' size='lg' color='white'>
          <I18n data={isWithdraw ? messages.withdraw_stablecoins : messages.deposit_stablecoins} />
        </Text>
      </BodyTitle>
      {rows.length > 0 && <Rows rows={rows} />}
      {rows.length === 0 && (
        <Empty>
          <I18n data={messages.stablecoins_unavailable} />
        </Empty>
      )}
    </ModalContainer>
  )
}

export default StableOptions
